import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import {
  ChecklistFeature,
  DroneFeature,
  OrderFeature,
  ProfileFeature,
  HistoryFeature,
  ZonesFeature,
  FleetFeature,
  AnalyticsFeature,
} from "@src/features";

const OperatorRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/history" element={<HistoryFeature />} />
      <Route path="/history/*" element={<HistoryFeature />} />
      <Route path="/analytics" element={<AnalyticsFeature />} />
      <Route path="/analytics/*" element={<AnalyticsFeature />} />
      <Route path="/orders" element={<OrderFeature />} />
      <Route path="/orders/*" element={<OrderFeature />} />
      <Route path="/zones" element={<ZonesFeature />} />
      <Route path="/zones/*" element={<ZonesFeature />} />
      <Route path="/drones" element={<DroneFeature />} />
      <Route path="/drones/*" element={<DroneFeature />} />
      <Route path="/fleet" element={<FleetFeature />} />
      <Route path="/fleet/*" element={<FleetFeature />} />
      <Route path="/profile" element={<ProfileFeature />} />
      <Route path="/profile/*" element={<ProfileFeature />} />
      <Route path="/checklist" element={<ChecklistFeature />} />
      <Route path="/checklist/*" element={<ChecklistFeature />} />
      <Route path="/" element={<Navigate to="/orders" replace />} />
      <Route path="*" element={<Navigate to="/orders" replace />} />
    </Routes>
  );
};

export default OperatorRoutes;
